import axios from "axios";
import { encryptData } from "../shared/utility";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
});

const buildURL = (url) => {
  let BaseUrl = process.env.REACT_APP_BASE_API_URL;
  return BaseUrl + url;
};

const buildHeader = () => {
  const data = {
    auth: process.env.REACT_APP_BIG_COMMERCE_ACCESS_TOKEN,
    generated_at: new Date().toISOString(),
    key: Math.random(),
  };
  const headers = {
    headers: {
      Auth: encryptData(data, process.env.REACT_APP_ID_ENCRYPTION_SECRET_KEY),
    },
  };

  return headers;
};

const buildStoreFrontHeader = () => {
  const header = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/vnd.bc.v1+json",
    },
  };

  return header;
};

const getRequest = async (url) => {
  const completeUrl = buildURL(url);
  return await axiosInstance.get(completeUrl, buildHeader());
};

const getRequestWithParams = async (url, params = null) => {
  const completeUrl = buildURL(url);
  return await axiosInstance.get(completeUrl, {
    ...buildHeader(),
    params: params || {},
  });
};

const deleteRequest = async (url) => {
  const completeUrl = buildURL(url);
  return await axiosInstance.delete(completeUrl, buildHeader());
};

const postRequest = async (url, dataObj = null) => {
  const completeUrl = buildURL(url);
  return await axiosInstance.post(completeUrl, dataObj, buildHeader());
};

const patchRequest = async (url, dataObj = null) => {
  const completeUrl = buildURL(url);
  return await axiosInstance.patch(completeUrl, dataObj, buildHeader());
};

const postRequestStoreFront = async (url, dataObj = null) => {
  const response = await axios.post(url, dataObj, buildStoreFrontHeader());
  return response.data?.data || response.data;
};

const putRequestStoreFront = async (url, dataObj) => {
  const response = await axios.put(url, dataObj, buildStoreFrontHeader());
  return response.data?.data || response.data;
};

const getRequestStoreFront = async (url) => {
  const response = await axios.get(url, buildStoreFrontHeader());
  return response.data;
};

const putRequest = async (url, dataObj) => {
  const completeUrl = buildURL(url);
  return await axiosInstance.put(completeUrl, dataObj, buildHeader());
};

export {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  getRequestWithParams,
  postRequestStoreFront,
  patchRequest,
  getRequestStoreFront,
  putRequestStoreFront,
};
